// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__3Mm5I","logoBox":"Navbar_logoBox__o+lh3"};